import React from "react";
import trashIcon from '../../images/icn-trash.svg';
import {
    Button
} from 'reactstrap';
import './ButonTrash.scss'

export const ButonTrash = ({ onClick }) => {
    return (
        <Button color="secondary" className="btn-plus" onClick={onClick}><img src={trashIcon} alt="" /> Elimina</Button>
    )
}